import { render, staticRenderFns } from "./ChatArea.vue?vue&type=template&id=2784df9c&scoped=true"
import script from "./ChatArea.vue?vue&type=script&lang=js"
export * from "./ChatArea.vue?vue&type=script&lang=js"
import style0 from "./ChatArea.vue?vue&type=style&index=0&id=2784df9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2784df9c",
  null
  
)

export default component.exports